import PayslipTemplate from "./PayslipTemplate"
import { forwardRef } from "react"
const ComponentToPrintAll = forwardRef(({ allPayslips }: any, ref: any) => {
  return (
    <div
      ref={ref}
      className=" gap-10 flex flex-col"
    >
      {allPayslips?.map((payslip: any, index: any) => (
        <PayslipTemplate
          key={index}
          data={payslip}
        />
      ))}
    </div>
  )
})

export default ComponentToPrintAll
